import styled, { css } from 'styled-components';
import { ToggleButtonGroup, spaceMixin, mediaMixin } from '@zillow/constellation';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)`
    && {
        margin-top: ${spaceMixin('sm')};

        > button {
            white-space: nowrap;

            width: 144px;

            ${mediaMixin('lg', css`
                width: 148px;
            `)}

            ${mediaMixin('xl', css`
                width: 150px;
            `)}

            ${mediaMixin('xxl', css`
                width: 208px;
            `)}
        }

        ${mediaMixin('lg', css`
            margin-top: 0px;
        `)}
    }
`;
